import { put, call } from "redux-saga/effects";
import * as services from "./service";
import * as types from "./types";
import * as actions from "./action";
import { toastr } from "react-redux-toastr";

export function* getAboutMicroserviceSaga(
  action: types.GetAboutMicroserviceActionType
) {
  try {
    const response: { data: any } = yield call(
      services.getAboutMicroserviceService,
      action.payload
    );
    yield put({
      type: actions.GET_ABOUT_MICROSERVICE_SUCCESS,
      response,
    });
  } catch (error) {
    let response = error as { error: any }
    yield put({
      type: actions.GET_ABOUT_MICROSERVICE_ERROR,
      error,
    });
    toastr.error("Microservice Not Loaded", `${response.error.message}`);
  }
}

export function* getAboutMicroservicesSaga(
  action: types.GetAboutMicroservicesActionType
) {
  try {
    const response: { data: any } = yield call(
      services.getAboutMicroservicesService,
      action.payload
    );
    yield put({
      type: actions.GET_ABOUT_MICROSERVICES_SUCCESS,
      response,
    });
  } catch (error) {
    let response = error as { error: any }
    yield put({
      type: actions.GET_ABOUT_MICROSERVICES_ERROR,
      error,
    });
    toastr.error("Microservice Not Loaded", `${response.error.message}`);
  }
}

export function* addAboutMicroserviceSaga(
  action: types.AddAboutMicroserviceActionType
) {
  try {
    const addResponse: { data: any } = yield call(
      services.addAboutMicroserviceService,
      action.payload
    );
    const getResponse: {} = yield call(services.getAboutMicroservicesService);
    if (addResponse.data) {
      yield put({
        type: actions.ADD_ABOUT_MICROSERVICE_SUCCESS,
        response: addResponse,
      });
      yield put({
        type: actions.GET_ABOUT_MICROSERVICES_SUCCESS,
        response: getResponse,
      });
      toastr.success("Microservice Added", `Added a new microservice`);
    } else {
      throw addResponse;
    }
  } catch (error) {
    let response = error as { error: any }
    yield put({
      type: actions.ADD_ABOUT_MICROSERVICE_ERROR,
      error,
    });
    toastr.error("Microservice could not be added", `${response.error.message}`);
  }
}

export function* modifyAboutMicroserviceSaga(
  action: types.ModifyAboutMicroserviceActionType
) {
  try {
    const modifyResponse: { data: any } = yield call(
      services.modifyAboutMicroserviceService,
      action.payload
    );
    const getResponse: {} = yield call(services.getAboutMicroservicesService);
    if (modifyResponse.data) {
      yield put({
        type: actions.MODIFY_ABOUT_MICROSERVICE_SUCCESS,
        response: modifyResponse,
      });
      yield put({
        type: actions.GET_ABOUT_MICROSERVICES_SUCCESS,
        response: getResponse,
      });
      toastr.success("Microservice Modified", `Success`);
    } else {
      throw modifyResponse;
    }
  } catch (error) {
    let response = error as { error: any }
    yield put({
      type: actions.MODIFY_ABOUT_MICROSERVICE_ERROR,
      error,
    });
    toastr.error("Microservice Not Modified", `${response.error.message}`);
  }
}

export function* deleteAboutMicroserviceSaga(
  action: types.DeleteAboutMicroserviceActionType
) {
  try {
    const deleteResponse: { data: any } = yield call(
      services.deleteAboutMicroserviceService,
      action.payload
    );
    const getResponse: {} = yield call(services.getAboutMicroservicesService);
    if (deleteResponse.data) {
      yield put({
        type: actions.DELETE_ABOUT_MICROSERVICE_SUCCESS,
        response: deleteResponse,
      });
      yield put({
        type: actions.GET_ABOUT_MICROSERVICES_SUCCESS,
        response: getResponse,
      });
      toastr.success("Microservice Deleted", `Success`);
    } else {
      throw deleteResponse;
    }
  } catch (error) {
    let response = error as { error: any }
    yield put({
      type: actions.DELETE_ABOUT_MICROSERVICE_ERROR,
      error,
    });
    toastr.error("Microservice Not Deleted", `${response.error.message}`);
  }
}
